module.exports = __webpack_public_path__ + "img/Ilustracion No tiene actividades.2c2c2cb6.svg";